import { createSignal } from '@verclam/pulsar';

export type ModelSidebarContext = {
	readonly modelId: number | null;
};

/**
 * `null` closes the panel. A non-null context edits the model carried by `modelId`; a `modelId` of
 * `null` inside an open context creates one instead.
 */
const modelSidebarSignal = createSignal<ModelSidebarContext | null>(null);

export const openModelSidebar = (modelId: number | null): void => {
	modelSidebarSignal.value = { modelId };
};

export const closeModelSidebar = (): void => {
	modelSidebarSignal.value = null;
};

export default modelSidebarSignal;
